(function () {
  'use strict';

  // ── Monthly price note (GBP only) ──────────────────────────────────────────

  if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'GBP') {
    var CURRENCY = '£';
    var observed = new WeakSet();

    function calcMonthly(price) {
      return price < 300
        ? (price / 3).toFixed(2)
        : ((price * 0.9) / 10).toFixed(2);
    }

    function parsePriceFromWrapper(wrapper) {
      // Sale cards render __saleprice, full-price cards render __price
      // (globo.filter.product.liquid) — read whichever exists.
      // Globo header search popup cards render .gl-card-price.
      var el = wrapper.querySelector('.spf-product-card__saleprice') ||
               wrapper.querySelector('.spf-product-card__price') ||
               wrapper.querySelector('.gl-card-price');
      if (!el) return null;
      var raw = el.textContent.replace(/[^\d.]/g, '');
      var n = parseFloat(raw);
      return isNaN(n) ? null : n;
    }

    function updateNote(wrapper) {
      var price = parsePriceFromWrapper(wrapper);
      if (price === null) return;

      var note = wrapper.querySelector('.fjc-monthly-note');

      var stored = wrapper.getAttribute('data-fjc-price');
      if (stored === String(price) && note) return;
      wrapper.setAttribute('data-fjc-price', price);

      if (!note) {
        note = document.createElement('span');
        note.className = 'fjc-monthly-note';
        wrapper.appendChild(note);
      }

      var monthly = calcMonthly(price);
      note.innerHTML =
        'from <strong>' + CURRENCY + monthly + '</strong>' +
        '/month';
    }

    function watchWrapper(wrapper) {
      if (observed.has(wrapper)) return;
      observed.add(wrapper);
      updateNote(wrapper);
      new MutationObserver(function () {
        updateNote(wrapper);
      }).observe(wrapper, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    // Collection/search page cards + Globo header search popup cards
    var PRICE_WRAPPERS = '.spf-product-card__price-wrapper, #glFilter-search-popup .gl-card-pricing';

    function scanAll() {
      document.querySelectorAll(PRICE_WRAPPERS).forEach(watchWrapper);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scanAll);
    } else {
      scanAll();
    }

    // Watch for price wrappers injected dynamically (Globo Filter re-renders)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(PRICE_WRAPPERS)) {
            watchWrapper(node);
          }
          node.querySelectorAll &&
            node.querySelectorAll(PRICE_WRAPPERS).forEach(watchWrapper);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    // ── Homepage "Most Loved" / "New In" carousel monthly note ──────────────
    function parseHomePrice(wrapper) {
      var el = wrapper.querySelector('.new-in-products__price--sale') ||
               wrapper.querySelector('span');
      if (!el) return null;
      var raw = el.textContent.replace(/[^\d.]/g, '');
      var n = parseFloat(raw);
      return isNaN(n) ? null : n;
    }

    function addHomeNote(wrapper) {
      if (wrapper.querySelector('.fjc-monthly-note')) return;
      var price = parseHomePrice(wrapper);
      if (price === null) return;
      var note = document.createElement('span');
      note.className = 'fjc-monthly-note';
      note.innerHTML =
        'from <strong>' + CURRENCY + calcMonthly(price) + '</strong>' +
        '/month';
      wrapper.appendChild(note);
    }

    function scanHomePrices() {
      document.querySelectorAll('.new-in-products__price').forEach(addHomeNote);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scanHomePrices);
    } else {
      scanHomePrices();
    }

    // ── PDP "You may also like" cards monthly note ────────────────────────
    function parseYmalPrice(wrapper) {
      var el = wrapper.querySelector('.price-sale') || wrapper.querySelector('span');
      if (!el) return null;
      var raw = el.textContent.replace(/[^\d.]/g, '');
      var n = parseFloat(raw);
      return isNaN(n) ? null : n;
    }

    function addYmalNote(wrapper) {
      if (wrapper.querySelector('.fjc-monthly-note')) return;
      var price = parseYmalPrice(wrapper);
      if (price === null) return;
      var note = document.createElement('span');
      note.className = 'fjc-monthly-note';
      note.innerHTML =
        'from <strong>' + CURRENCY + calcMonthly(price) + '</strong>' +
        '/month';
      wrapper.appendChild(note);
    }

    function scanYmalCards() {
      document.querySelectorAll('.x-card-price').forEach(addYmalNote);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scanYmalCards);
    } else {
      scanYmalCards();
    }

    // Watch for YMAL cards injected after the recommendations AJAX call
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('x-card-price')) {
            addYmalNote(node);
          }
          node.querySelectorAll &&
            node.querySelectorAll('.x-card-price').forEach(addYmalNote);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ── MTO panel — cart icon hover & click ───────────────────────────────────

  // Read the currently-selected <option> for a card's variant <select>.
  function getSelectedVariantOption(card) {
    var sel = card.querySelector('.spf-product__variants');
    if (!sel) return null;
    return sel.options[sel.selectedIndex] || null;
  }

  // Made-to-order = out of stock (qty <= 0) AND the variant is set to
  // "continue selling when out of stock" (inventory_policy == 'continue').
  // Only these variants get the "30 working days" MTO panel — this is why
  // rings and chains (continue policy) still show it correctly.
  //
  // Deny-policy variants at qty 0 are genuinely SOLD OUT (e.g. pendants) and
  // must NOT get the MTO treatment. They fall through to the native sold-out
  // card state, matching what the PDP shows. data-inventory-policy is already
  // stamped on every <option> in globo.filter.product.liquid, so no Liquid
  // change is needed.
  function isMadeToOrder(card) {
    var opt = getSelectedVariantOption(card);
    if (!opt) return false;
    var qty = parseInt(opt.getAttribute('data-inventory-quantity'), 10);
    if (isNaN(qty) || qty > 0) return false;
    var policy = (opt.getAttribute('data-inventory-policy') || '').toLowerCase();
    return policy === 'continue';
  }

  // Out of stock = selected variant qty <= 0, regardless of policy.
  function isOutOfStock(card) {
    var opt = getSelectedVariantOption(card);
    if (!opt) return false;
    var qty = parseInt(opt.getAttribute('data-inventory-quantity'), 10);
    return !isNaN(qty) && qty <= 0;
  }

  function showMtoPanel(card) {
    var panel = card.querySelector('.fjc-mto-panel');
    if (!panel) return;
    panel.classList.add('fjc-mto-panel--active');
    clearTimeout(panel._fjcTimer);
    panel._fjcTimer = setTimeout(function () {
      panel.classList.remove('fjc-mto-panel--active');
    }, 2500);
  }

  function hideMtoPanel(card) {
    var panel = card.querySelector('.fjc-mto-panel');
    if (panel) panel.classList.remove('fjc-mto-panel--hover');
  }

  // Attach hover/click handlers to the cart icon button and the MTO panel.
  // - Button mouseenter shows the panel.
  // - Button mouseleave hides the panel UNLESS the mouse moved onto the panel.
  // - Panel mouseenter keeps it visible; panel mouseleave hides it.
  // - Panel click submits the cart form (same as the ATC button).
  function attachCardHover(card) {
    if (card._fjcHover) return;
    card._fjcHover = true;

    var btn   = card.querySelector('.fjc-atc-trigger');
    var panel = card.querySelector('.fjc-mto-panel');

    function showPanel() {
      if (panel) panel.classList.add('fjc-mto-panel--hover');
    }
    function hidePanel() {
      if (panel) panel.classList.remove('fjc-mto-panel--hover');
    }

    if (btn) {
      btn.addEventListener('mouseenter', function () {
        if (window.innerWidth < 1024) return;
        if (card.closest('[data-fjc-ring="true"]')) return; // rings/earrings: no MTO panel
        if (!isMadeToOrder(card)) return; // deny-policy OOS (pendants) get no panel
        showPanel();
      });
      btn.addEventListener('mouseleave', function (e) {
        // Keep panel if mouse is moving onto the panel itself
        var related = e.relatedTarget;
        if (panel && related && (related === panel || panel.contains(related))) return;
        hidePanel();
      });
    }

    if (panel) {
      panel.addEventListener('mouseenter', function () {
        if (window.innerWidth < 1024) return;
        if (!isMadeToOrder(card)) return; // deny-policy OOS (pendants) get no panel
        showPanel();
      });
      panel.addEventListener('mouseleave', hidePanel);
      panel.addEventListener('click', function () {
        var form = card.querySelector('.spf-product__form');
        if (!form) return;
        // requestSubmit fires the submit event (triggering Globo's AJAX cart handler)
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      });
    }
  }

  function scanAllCards() {
    document.querySelectorAll('.spf-product-card').forEach(attachCardHover);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAllCards);
  } else {
    scanAllCards();
  }

  // Click: prevent cart submission when OOS, show MTO panel only for
  // made-to-order (continue-selling) items.
  // - Rings/earrings use the size drawer instead (skipped here).
  // - In stock: let the form submit normally.
  // - Out of stock + continue policy (bracelets, chains): show 30-day panel.
  // - Out of stock + deny policy (pendants): block submit, show nothing — the
  //   card already renders its native sold-out state.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fjc-atc-trigger');
    if (!btn) return;
    var card = btn.closest('.spf-product-card');
    if (!card) return;
    if (card.closest('[data-fjc-ring="true"]')) return; // rings/earrings: drawer handles it
    if (!isOutOfStock(card)) return; // in-stock: let the form submit normally
    // Out of stock: never submit an OOS item from the card.
    e.preventDefault();
    if (isMadeToOrder(card)) {
      showMtoPanel(card);
    }
  });

  // Watch for cards injected dynamically (Globo Filter re-renders on filter change)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('spf-product-card')) {
          attachCardHover(node);
        }
        node.querySelectorAll &&
          node.querySelectorAll('.spf-product-card').forEach(attachCardHover);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

}());
